import { Link } from "react-router-dom";
import { DownloadFileByFileStoreId } from "./DownloadFileByFileStoreId";
import { NavLinkComponent } from "./NavLinkComponent";
import { ReDirectToeKMC2 } from "./ReDirectToeKMC2";

const renderCollapseChild = (item, index, t) => {
  switch (item.type) {
    case "link":
      return (
        <Link className="nav-link fontSizeClass" to={item.to} key={index}>
          {t(item.label)}
        </Link>
      );
    case "anchor":
      return (
        <a
          className="nav-link fontSizeClass"
          href={item.href}
          target={item.target || undefined}
          rel={item.target === "_blank" ? "noreferrer" : undefined}
          key={index}
        >
          {t(item.label)}
        </a>
      );
    case "filestore":
      return (
        <>
          <DownloadFileByFileStoreId
            key={index}
            fileStoreId={item.fileStoreId}
            label={item.label}
          />
        </>
      );
    case "redirect":
      return <ReDirectToeKMC2 label={item.label} key={index} />;
    default:
      return null;
  }
};

export const RenderNavItem = ({ item, index, t }) => {
  switch (item.type) {
    case "link":
      return (
        <li className="nav-item" key={index}>
          <NavLinkComponent
            label={item.label}
            to={item.to}
            activePaths={item.activePaths}
          />
        </li>
      );

    case "anchor":
      return (
        <li className="nav-item" key={index}>
          <a
            className="nav-link fontSizeClass"
            href={item.href}
            target="_blank"
            rel="noreferrer"
          >
            {t(item.label)}
          </a>
        </li>
      );

    case "collapse":
      return (
        <li className="nav-item" key={index}>
          <button
            type="button"
            className="btn"
            data-toggle="collapse"
            data-target={`#${item.id}`}
          >
            {t(item.label)}
            <i className="bi bi-chevron-down" />
          </button>
          <div id={item.id} className="collapse">
            {item.children.map((child, i) => renderCollapseChild(child, i, t))}
          </div>
        </li>
      );

    case "filestore":
      return (
        <li className="nav-item" key={index}>
          <DownloadFileByFileStoreId
            fileStoreId={item.fileStoreId}
            label={item.label}
          />
        </li>
      );

    case "redirect":
      return (
        <li className="nav-item" key={index}>
          <ReDirectToeKMC2 label={item.label} />
        </li>
      );

    default:
      return null;
  }
};
